import { render } from "./enroll-success-popup.vue?vue&type=template&id=643d5f0a&scoped=true&ts=true"
import script from "./enroll-success-popup.vue?vue&type=script&lang=ts"
export * from "./enroll-success-popup.vue?vue&type=script&lang=ts"

import "./enroll-success-popup.vue?vue&type=style&index=0&id=643d5f0a&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643d5f0a"]])

export default __exports__